import { render, staticRenderFns } from "./RefsPersonGroup.vue?vue&type=template&id=317cba8c&scoped=true"
import script from "./RefsPersonGroup.vue?vue&type=script&lang=ts"
export * from "./RefsPersonGroup.vue?vue&type=script&lang=ts"
import style0 from "./RefsPersonGroup.vue?vue&type=style&index=0&id=317cba8c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317cba8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSkeletonLoader,VSpacer})
